import styles from './Modal.module.css';

/**
 * Modal
 * ─────
 * Generic modal overlay. Clicking the overlay calls onClose.
 *
 * @param {string}    title     Header title
 * @param {Function}  onClose   Called when overlay or back button clicked
 * @param {ReactNode} children  Modal body content
 * @param {ReactNode} actions   Footer action buttons (replaces default close button)
 * @param {string}    [size]    'sm' | 'md' (default) | 'lg'
 *
 * Usage:
 *   <Modal title="Cancel Pledge" onClose={closeCancel} actions={<>
 *     <button className="btn btn-ghost" onClick={closeCancel}>Back</button>
 *     <button className="btn btn-danger" onClick={handleCancel}>Confirm</button>
 *   </>}>
 *     <p>Are you sure?</p>
 *   </Modal>
 */
export default function Modal({ title, onClose, children, actions, size = 'md' }) {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={`${styles.modal} ${styles[size] || ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="card-header">
            <h3>{title}</h3>
          </div>
        )}
        <div className={styles.body}>{children}</div>
        {actions && <div className="modal-actions">{actions}</div>}
      </div>
    </div>
  );
}
